import list from './list'
import search from './search'
import details from './details'
import update from './update'
import updateMany from './updateMany'
import team from './team'
import space from './space'
import employee from './employee'
import seatedCount from './seatedCount'

export default {
  list,
  search,
  details,
  update,
  team,
  updateMany,
  space,
  employee,
  seatedCount,
}
